var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.665 0.716942L0.934973 7.55394C-0.275027 8.03994 -0.268027 8.71494 0.712973 9.01594L5.26497 10.4359L15.797 3.79094C16.295 3.48794 16.75 3.65094 16.376 3.98294L7.84297 11.6839H7.84097L7.84297 11.6849L7.52897 16.3769C7.98897 16.3769 8.19197 16.1659 8.44997 15.9169L10.661 13.7669L15.26 17.1639C16.108 17.6309 16.717 17.3909 16.928 16.3789L19.947 2.15094C20.256 0.911942 19.474 0.350942 18.665 0.716942Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.ed57ae5d41337185841719dd7f107398.svg";
export { ForwardRef as ReactComponent };